import styled, { css, StyledComponent } from 'styled-components';

export const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  justify-items: center;
  margin-bottom: 10px;
  padding-right: 20px;
`;

export const Title = styled.div`
  height: 20px;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;

  display: flex;
  align-items: center;
  letter-spacing: -0.01em;

  color: rgba(0, 0, 0, 0.65);
`;

export const DeleteAllButton: StyledComponent<'div', any> = styled.div`
  height: 20px;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.01em;
  color: rgba(0, 0, 0, 0.45);
  cursor: pointer;
`;

interface IFooter {
  disabled?: boolean;
}

export const Footer: StyledComponent<'div', any, IFooter> = styled.div<IFooter>`
  width: 100%;
  height: 40px;

  display: flex;
  align-items: center;
  padding: 0 16px;
  gap: 12px;

  background: #f7f7f7;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  cursor: pointer;

  ${({ disabled }) => {
    if (disabled) {
      return css`
        cursor: not-allowed;
      `;
    }
    return;
  }}
`;
